import {useId} from 'react'
import {CrossGlowShape} from './CrossGlowShape'

export const CrossGlowBackground = () => {
  const leftId = useId().replace(/:/g, '')
  const rightId = useId().replace(/:/g, '')

  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
      <div className="absolute left-[-50%] top-1/2 w-[105%] -translate-y-1/2 -rotate-90 -scale-x-100 md:left-[-10%] md:w-[75%]">
        <div className="motion-safe:animate-blob-float-a" style={{animationDuration: '32s'}}>
          <CrossGlowShape uid={`input-blob-section-left-${leftId}`} />
        </div>
      </div>
      <div className="absolute right-[-50%] top-1/2 w-[105%] -translate-y-1/2 rotate-90 -scale-x-100 md:right-[-10%] md:w-[75%]">
        <div className="motion-safe:animate-blob-float-b" style={{animationDuration: '40s'}}>
          <CrossGlowShape uid={`input-blob-section-right-${rightId}`} />
        </div>
      </div>
    </div>
  )
}
